/**
 * Pet Profile Service
 * Handles all API calls for customer pet profile management
 */

import { apiService } from "./api";
import { API_CONFIG, buildUrl } from "../config/api";
import { Pet, PetPayload } from "../types";

class PetService {
    async getCustomerPets(customerId: string): Promise<Pet[]> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.PETS.BY_CUSTOMER, { id: customerId });
        return apiService.get<Pet[]>(url);
    }

    async createPet(
        customerId: string,
        data: PetPayload & Pick<Pet, "name" | "species">
    ): Promise<Pet> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.PETS.BY_CUSTOMER, { id: customerId });
        return apiService.post<Pet>(url, data);
    }

    async updatePet(
        petId: string,
        data: PetPayload
    ): Promise<Pet> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.PETS.DETAIL, { id: petId });
        return apiService.put<Pet>(url, data);
    }

    async deletePet(petId: string): Promise<void> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.PETS.DETAIL, { id: petId });
        return apiService.delete<void>(url);
    }

    async uploadPetPhoto(petId: string, file: File): Promise<Pet> {
        const formData = new FormData();
        formData.append("file", file);

        const url = buildUrl(API_CONFIG.ENDPOINTS.PETS.PHOTO, { id: petId });
        return apiService.post<Pet>(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            timeout: 60000, // 60s for image upload + R2 processing
        });
    }

    async deletePetPhoto(petId: string): Promise<Pet> {
        const url = buildUrl(API_CONFIG.ENDPOINTS.PETS.PHOTO, { id: petId });
        return apiService.delete<Pet>(url);
    }
}

export const petService = new PetService();
